function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.932 13.72a4.44 4.44 0 014.434 4.246l.004.193v.888a1.775 1.775 0 01-1.642 1.77l-.133.005H5.166a1.775 1.775 0 01-1.77-1.642l-.005-.133v-.888a4.439 4.439 0 014.246-4.434l.192-.005h7.103zM11.38 3.067a4.439 4.439 0 110 8.877 4.439 4.439 0 010-8.877z",
  fill: "#0073FF"
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 17.133,
  y: 6.738,
  width: 4.476,
  height: 1.8,
  rx: 0.9,
  fill: "#0073FF",
  fillOpacity: 0.3
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 18.023,
  y: 9.538,
  width: 3.585,
  height: 1.8,
  rx: 0.9,
  fill: "#0073FF",
  fillOpacity: 0.3
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 18.919,
  y: 12.337,
  width: 2.69,
  height: 1.8,
  rx: 0.9,
  fill: "#0073FF",
  fillOpacity: 0.3
});

var SvgContactsActive = function SvgContactsActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default SvgContactsActive;